<img
  id="imgPlantSolarLayout"
  alt="Plant Solar Layout Image"
  fxLayoutAlign="center flex-end"
  fxFlex="100%;"
  fxLayout="row wrap"
  style="
    background-size: cover;
    background-repeat: no-repeat;
    background-position: content-box;
  "
/>
